import produce from "immer";
import { Container } from "unstated";

import { getFight, sendJurorOrder } from "../api";
import { Fight } from "../Interfaces";

import { emptyFight } from "../constants";

interface State {
	fight: Fight;
}

export default class FightContainer extends Container<State> {
	public state = { fight: emptyFight };

	public async init(fightId: number) {
		this.setState({ fight: await getFight(fightId) });
	}

	public setJurorOrder = async (jurorIDs: number[]) => {
		this.setState(
			produce((state) => {
				jurorIDs.forEach(
					(jurorID, position) => (state.fight.jurors[jurorID].position = position + 1)
				);
			})
		);
		const jurorOrder = jurorIDs.map((jurorId, i) => {
			return { juror_id: jurorId, position: i + 1 };
		});
		const oldJurorIds = Object.keys(this.state.fight.jurors)
			.map((key) => this.state.fight.jurors[key])
			.sort((a, b) => a.position - b.position)
			.map((juror) => juror.id);
		const password = localStorage.getItem("sypt_fight_password");
		try {
			if (!password) {
				throw new Error("password undefined");
			}
			const res = await sendJurorOrder(this.state.fight.id, password, {
				fight_id: this.state.fight.id,
				jurorOrder,
			});
			if (res.success !== true) {
				this.setState(
					produce((state) => {
						oldJurorIds.forEach(
							(jurorID, position) => (state.fight.jurors[jurorID].position = position + 1)
						);
					})
				);
			}
		} catch (e) {
			// tslint:disable-next-line:no-console
			console.log(e, "reverting to old juror Order");
			this.setState(
				produce((state) => {
					oldJurorIds.forEach(
						(jurorID, position) => (state.fight.jurors[jurorID].position = position + 1)
					);
				})
			);
		}
	};
}



// WEBPACK FOOTER //
// ./src/FightRoom/FightContainer.tsx